import CURRENCY_CODE_SYMBOL_MAP from '../constants/currencyCodeSymbolMap';

const getCurrencySymbol = (currencyCode: string): string => {
  const currencyCodeSymbolMap = new Map(Object.entries(CURRENCY_CODE_SYMBOL_MAP));

  if (!currencyCodeSymbolMap.has(currencyCode)) {
    return currencyCode;
  }

  return currencyCodeSymbolMap.get(currencyCode) as string;
};

export default getCurrencySymbol;
